import {
    actionCreator,
    API_URL,
    checkHttpStatus,
    create_post_data,
    createRequestActionTypes,
    createSearchUrl,
    jsonApiHeader,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage,
} from '../../../../../../../../actions/utilAction';

export {
    jsonApiHeader,
    showWarningMessage,
    showErrorMessage,
    actionCreator,
    checkHttpStatus,
    create_post_data,
    createSearchUrl,
    showSuccessMessage
};

export const POST_SKILLACQUISITIONPROGRAM_API = `${API_URL}/api/PatientSkillAcquisitionProgram/SavePatientSkillAcqProgram`;
export const POST_SKILLACQUISITIONPROGRAMFROMLIBRARY_API = `${API_URL}/api/PatientSkillAcquisitionProgram/SavePatientSkillAcqProgramFromLibrary`;
export const GET_SKILLACQUISITIONPROGRAM_LIST_API = `${API_URL}/api/PatientSkillAcquisitionProgram/GetPatientSkillAcqPrograms`;
export const GET_SKILLACQUISITIONPROGRAM_DETAIL_API = `${API_URL}/api/PatientSkillAcquisitionProgram/GetPatientSkillAcqProgramById`;
export const DELETE_SKILLACQUISITIONPROGRAM_API = `${API_URL}/api/PatientSkillAcquisitionProgram/DeletePatientSkillAcqProgram`;
export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;
export const PROGRAM_STATUS_ACTIVATION = `${API_URL}/api/PatientSkillAcquisitionProgram/UpdateProgramActiveStatus`;
export const PATCH_PROGRAM_INSTRUCTION = `${API_URL}/api/PatientSkillAcquisitionProgram/UpdateProgramInstruction`;
export const GET_MASTER_CURRICULAM_LIBRARIES_API = `${API_URL}/api/MasterCurriculumLibrary/GetMasterCurriculumLibraries`;
export const GET_MASTER_DOMIANS_BY_LIBRARY_API = `${API_URL}/api/MasterDomains/GetMasterDomainsByLibraryId`;
export const GET_MASTER_PROGRAMS_BY_DOMAIN_API = `${API_URL}/api/MasterPrograms/GetMasterProgramsByDomainId`;
export const POST_COPYPATIENTSKILLACQUISITIONPROGRAM_API = `${API_URL}/api/PatientSkillAcquisitionProgram/CopyPatientSkillAcquisitionProgram`;
export const GET_GETPATIENTSKILLACQUISITIONPROGRAMSINGLEGRAPH_API = `${API_URL}/api/PatientSkillAcquisitionProgram/GetPatientSkillAcquisitionProgramSingleGraph`;


export const skillAcquisitionProgramActionTypes = {
    get_masterData: createRequestActionTypes('GET_MASTERDATA'),
    save_skillAcquisitionProgram: createRequestActionTypes('SAVE_SKILLACQUISITIONPROGRAM'),
    save_skillAcquisitionProgramFromLibrary: createRequestActionTypes('SAVE_SKILLACQUISITIONPROGRAMFROMLIBRARY'),
    get_skillAcquisitionProgramList: createRequestActionTypes('GET_SKILLACQUISITIONPROGRAMLIST'),
    get_skillAcquisitionProgramDetail: createRequestActionTypes('GET_SKILLACQUISITIONPROGRAMDETAIL'),
    delete_skillAcquisitionProgram: createRequestActionTypes('DELETE_SKILLACQUISITIONPROGRAM'),
    // delete_skillAcquisitionProgram: createRequestActionTypes('DELETE_SKILLACQUISITIONPROGRAM'),
    program_active_status: createRequestActionTypes('PROGRAM_ACTIVE_STATUS'),
    patch_program_instruction: createRequestActionTypes('PATCH_PROGRAM_INSTRUCTION'),
    get_masterCurriculumLibraries: createRequestActionTypes('GET_MASTERCURRICULUMLIBRARIES'),
    get_masterDomainsByLibrary: createRequestActionTypes('GET_MASTERDOMAINSBYLIBRARY'),
    get_masterprogramByDomain: createRequestActionTypes('GET_MASTERPROGRAMBYDOMAIN'),
    save_copyPatientSkillAcquisitionProgram: createRequestActionTypes('SAVE_COPYPATIENTSKILLACQUISITIONPROGRAM'),
    get_getPatientSkillAcquisitionProgramSingleGraph: createRequestActionTypes('GET_GETPATIENTSKILLACQUISITIONPROGRAMSINGLEGRAPH'),
};

export const MODULE = 'DCMASTER_SKILLACQUISITIONPROGRAM';


// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SkillAquisition/components/Program/constants/ApiConstants.js